import script from "./PsdsDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PsdsDataForm.vue?vue&type=script&setup=true&lang=js"

import "./PsdsDataForm.vue?vue&type=style&index=0&id=3e4188ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4188ac"]])

export default __exports__